<span class="checkbox" (click)="toggle()" [class.disabled]="disabled" [style.font-size]="fontsize">
    <i class="{{ _value ? 'fas fa-check-square' : 'far fa-square' }} me-2"></i>
    <span [style.font-weight]="fontweight">{{ label }}</span>
</span>
